'use strict'

export default (mockAxios) => {
  // 一覧
  mockAxios.onGet(`/exlocations`).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'name': 'サンプル場所',
        'seqno': 18
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // 交換場所情報取得
  mockAxios.onGet(new RegExp(`/exlocations/\\d+`)).reply(200, {
    'success': true,
    'data': {
      'id': 1,
      'name': 'サンプル場所',
      'seqno': 18
    }
  })

  // 新規登録
  mockAxios.onPost(`/exlocations`).reply(201, {
    'success': true,
    'data': {
      'id': 1
    }
  })

  // 変更
  mockAxios.onPut(new RegExp(`/exlocations/\\d+`)).reply(201, {
    'success': true,
    'data': {
    }
  })

  // 削除
  mockAxios.onDelete(new RegExp(`/exlocations/\\d+`)).reply(200, {
    'success': true,
    'data': {
    }
  })

  // 選択用交換場所情報一覧
  mockAxios.onGet(`/exlocations/choices`).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'name': 'サンプル場所'
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/exlocationRepositoryMock.js